import docIdFilter from '@/filters/page-filter.js'
import commonFilter from '@/filters/common-filter.js'
export default{
    ...docIdFilter,
    ...commonFilter
}



// WEBPACK FOOTER //
// ./src/filters/index.js